const Scissors = () => {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="3.5"
                cy="15.5"
                r="2.5"
                stroke="#2450BF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6 16L13.5 5.5" stroke="#2450BF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 16L4.5 5.5" stroke="#2450BF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle
                cx="14.5"
                cy="15.5"
                r="2.5"
                stroke="#2450BF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 1L9 3" stroke="#2450BF" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M9 6L9 8" stroke="#2450BF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default Scissors
